import { match } from 'ts-pattern';
import { memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { implementCustomExpressions } from '../__generated/implementation.js';
import { FenixVariant, Legs3DRonde, LegsCono, LegsEbonu3Eik, LegsEbonu3Staal, LegsElmo, LegsHarper3, LegsJulio3, LegsJulio4, LegsMadrid, LegsNewly, LegsNovaroEik, LegsNovaroStaal, LegsOdil3, LegsOdil4, LegsOslo, LegsPino, LegsRobuEik, LegsRobuStaal, LegsRoia, LegsTPootRonde, LegsTwist3, TopColorCeramic, TopMaterial } from '../__generated/model/index.js';
import { BASE_PRICE_MAP_CIRCLE_CERAMIC, BASE_PRICE_MAP_CIRCLE_FENIX_BIRCH, BASE_PRICE_MAP_CIRCLE_FENIX_SOLID, BASE_PRICE_MAP_CIRCLE_OAK_30, BASE_PRICE_MAP_CIRCLE_OAK_40 } from '../data/prices.js';
const ALL_DIAMETERS = [
    1000,
    1100,
    1200,
    1300,
    1350,
    1400,
    1500,
    1580,
    1600,
    1700,
    1800
];
const AVAILABLE_DIAMETERS_SOLID_OAK = [
    1000,
    1100,
    1200,
    1300,
    1400,
    1500,
    1600,
    1700,
    1800
];
const AVAILABLE_DIAMETERS_CERAMIC_TO_1350 = [
    1000,
    1100,
    1200,
    1300,
    1350
];
const AVAILABLE_DIAMETERS_CERAMIC_TO_1400 = [
    1000,
    1100,
    1200,
    1300,
    1400
];
const AVAILABLE_DIAMETERS_CERAMIC_TO_1600 = [
    1000,
    1100,
    1200,
    1300,
    1350,
    1400,
    1500,
    1600
];
const AVAILABLE_DIAMETERS_FENIX_BIRCH = [
    1000,
    1100,
    1200,
    1300,
    1350,
    1400
];
const AVAILABLE_DIAMETERS_FENIX_SOLID = [
    1000,
    1100,
    1200,
    1300,
    1350,
    1400,
    1500,
    1580
];
const DIAMETER_OPTIONS = ALL_DIAMETERS.map((diameter)=>({
        value: diameter,
        label: `${diameter / 10} cm`
    }));
const AVAILABLE_LEG_TYPES_CIRCLE = [
    Legs3DRonde.type,
    LegsCono.type,
    LegsEbonu3Eik.type,
    LegsEbonu3Staal.type,
    LegsElmo.type,
    LegsHarper3.type,
    LegsJulio3.type,
    LegsJulio4.type,
    LegsMadrid.type,
    LegsNewly.type,
    LegsNovaroEik.type,
    LegsNovaroStaal.type,
    LegsOdil3.type,
    LegsOdil4.type,
    LegsOslo.type,
    LegsPino.type,
    LegsRobuEik.type,
    LegsRobuStaal.type,
    LegsRoia.type,
    LegsTPootRonde.type,
    LegsTwist3.type
];
export const topCircleExpressions = implementCustomExpressions({
    TopCircle: {
        $availableDiameters: memoEval((self)=>[
                self.color,
                self.fenixVariant,
                self.material
            ], (color, fenixVariant, material)=>match(material).with(TopMaterial.SolidOak, ()=>AVAILABLE_DIAMETERS_SOLID_OAK).with(TopMaterial.Ceramic, ()=>match(color).with(TopColorCeramic.CuarzoReno, TopColorCeramic.NeroZimbabwe, TopColorCeramic.BiancoSupreme, TopColorCeramic.BiancoSupreme, TopColorCeramic.CalacataVaglie, TopColorCeramic.TajMahal, TopColorCeramic.MacchiaVecchia, TopColorCeramic.CalacataNaturel, TopColorCeramic.BlueStoneNegro, TopColorCeramic.CeppoDeGre, TopColorCeramic.NeroArdi, TopColorCeramic.PaladioNaturel, TopColorCeramic.CalceGrigio, TopColorCeramic.TitanCemento, TopColorCeramic.LavaCorten, TopColorCeramic.BasicNieve, ()=>AVAILABLE_DIAMETERS_CERAMIC_TO_1600).with(TopColorCeramic.Travertin, TopColorCeramic.CalacataGold, ()=>AVAILABLE_DIAMETERS_CERAMIC_TO_1400).with(TopColorCeramic.SurfaceSand, TopColorCeramic.SurfaceOffWhite, TopColorCeramic.NoirDesir, TopColorCeramic.SurfaceCoolGrey, TopColorCeramic.HyperWhite, TopColorCeramic.DarkBlack, TopColorCeramic.ClassicCarrara, ()=>AVAILABLE_DIAMETERS_CERAMIC_TO_1350).otherwise(()=>ALL_DIAMETERS)).with(TopMaterial.Fenix, ()=>fenixVariant === FenixVariant.Solid ? AVAILABLE_DIAMETERS_FENIX_SOLID : AVAILABLE_DIAMETERS_FENIX_BIRCH).exhaustive()),
        $availableLegTypes: ()=>AVAILABLE_LEG_TYPES_CIRCLE,
        $basePrice: memoEval((self)=>[
                self.diameter,
                self.fenixVariant,
                self.material,
                self.thickness
            ], (diameter, fenixVariant, material, thickness)=>{
            const priceMap = match(material).with(TopMaterial.SolidOak, ()=>thickness === 30 ? BASE_PRICE_MAP_CIRCLE_OAK_30 : BASE_PRICE_MAP_CIRCLE_OAK_40).with(TopMaterial.Ceramic, ()=>BASE_PRICE_MAP_CIRCLE_CERAMIC).with(TopMaterial.Fenix, ()=>fenixVariant === FenixVariant.Birch ? BASE_PRICE_MAP_CIRCLE_FENIX_BIRCH : BASE_PRICE_MAP_CIRCLE_FENIX_SOLID).exhaustive();
            return priceMap.get(diameter) ?? 0;
        }),
        $descriptionDimensions: (self)=>`${self.diameter / 10}cm \u2300/${self.thickness}mm`,
        $diameterOptions: ()=>DIAMETER_OPTIONS,
        $objectName: (self)=>self.fenixVariant === FenixVariant.Birch ? 'FENIX_OVAAL_OVAL' : 'OVAAL_OVAL',
        $repeatX: (self)=>{
            if (TopColorCeramic.is(self.color)) {
                return self.diameter / self.$ceramicRepeatRatio;
            }
            return self.diameter / self.$woodRepeatRatio;
        },
        $repeatY: (self)=>self.$repeatX
    }
});

//# sourceMappingURL=top-circle.js.map